import { palette } from '@primeuix/themes'

// Midtones are shared by the theme picker, UI severities and charts.
export const workspaceColors = {
  emerald: '#328265',
  green: '#518050',
  lime: '#778435',
  orange: '#bf7047',
  amber: '#a67a29',
  yellow: '#948024',
  teal: '#27847e',
  cyan: '#2c839c',
  sky: '#377fa8',
  blue: '#3978b6',
  indigo: '#626db0',
  violet: '#8667ac',
  purple: '#9366a2',
  fuchsia: '#a35d95',
  pink: '#ae6085',
  rose: '#b76375',
  red: '#ba5c59',
} as const

export const workspacePrimitives = Object.fromEntries(
  Object.entries(workspaceColors).map(([name, color]) => [
    name,
    palette(color) as Record<number, string>,
  ])
)
